class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

// Mobile nav country selector
document.addEventListener('DOMContentLoaded', () => {
  const countrySelect = document.querySelector('.f-mobile-nav__country-select')
  if (countrySelect) {
    countrySelect.addEventListener('change', (e) => {
      const form = e.target.closest('form')
      if (form) {
        form.submit()
      }
    })
  }
})
